import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import Spinner from '../../components/common/Spinner';
import { getCoinAmount } from '../../helpers/Utils'
import moment from 'moment';
import axios from 'axios';
import AOS from "aos";
import "aos/dist/aos.css";

import { AssetsLogUrl } from '../../shared/constants';

const Details = ( {currentUser, assets}) => {
  
  const navigate = useNavigate();

  const [isLoaded, setIsLoaded] = useState(false);
  const [mdticoin, setMDTI] = useState('');
  const [isAssetsLoading, setLoading ] =  useState(false);
  const [assetsLog, setAssetsLog] = useState([]);

    useEffect(() => {
    AOS.init();
    onInit();
    
    const MDTICoin = assets.find((n)=> {return n.token_type === 'MDTI'});
    if (MDTICoin !== undefined) setMDTI(MDTICoin);

  }, []);

  const onInit = async () => {
    const token = localStorage.getItem('userToken');
    if (token === null || token ==='') return;
    const sendlogdata ={ search: '', token_type : '',selected: 1, perPage: 20 }
      axios
        .post( AssetsLogUrl , sendlogdata , { headers: { Authorization: `Bearer ${token}` } } )
        .then((data) => {
          if (data.data.count >=0){
            setAssetsLog(data.data.select);
            setIsLoaded(true);
          }
          setLoading(true);
        })
        .catch((err) => {
          console.log(err);
        });
    }

  function getLogType(log) {
    switch(log) {
      case 1: return 'Assets Added';
      case 2: return 'Assets Deleted';
      case 3: return 'Withdrawal Completed';
      case 4: return 'Withdrawal Reject';
      default : return '';
   }
  }

  const linkTo = (link) => {
    navigate('/' + link);
  }
  
  return !isLoaded ? (
    <Spinner />
  ) : (
    <section>
      <div className="taps">
        <div className="tap_bt tapon">MDTI</div>
      </div>
      <div className="pcp_step1">
        <div className="pcp_step1a">
          <div className="pcp_hf" data-aos="fade-up">
            
            <p>Available balance</p>
            <b>{getCoinAmount(mdticoin.available_amount, 2, 'essence')}.<span> {getCoinAmount(mdticoin.available_amount, 2, 'decimal')} MDTI</span></b>
          </div>
          <div className="leftline"></div>
          <div className="pcp_hf" data-aos="fade-up">
            <p>Frozen balance</p>
            <b>{getCoinAmount(mdticoin.frozen_amount,2, 'essence')}.<span> {getCoinAmount(mdticoin.frozen_amount, 2, 'decimal')} MDTI</span></b>
          </div>
        </div>

        <div className="pcp_con" data-aos="fade-up">
          <div className="pcp_title">
            <b>Lockup balance</b>
            <span><b>{getCoinAmount(mdticoin.locked_amount, 2, 'essence')}.<i>{getCoinAmount(mdticoin.locked_amount, 2, 'decimal')} MDTI</i></b><img src="images/icon_arr_r.svg" alt="" /></span>
          </div>
          <button type="button" className="btty2" onClick={() => linkTo('withdrawal')}>Withdraw</button>
        </div>
      </div>

      <div className="pcp_step2">
        <div className="mtitle"><b>Transaction</b></div>

        { !isAssetsLoading?
          <Spinner />
          :
          assetsLog.map((item, i) => (
            <div className="pcp_list" data-aos="fade-left" key={i}>
              <div className={Number(item.amount)>=0?"pcp_icon pcp_bg1":"pcp_icon pcp_bg2"}><img src={Number(item.amount)>=0?"images/icon_in.svg":"images/icon_out.svg"} alt="" /></div>
              <div className="pcp_list1"><p>{getLogType(item.log_type)}</p><span>{moment(item.created_at).format('YYYY-MM-DD HH:mm:ss')}</span></div>
              <div className="pcp_list2"><i>{getCoinAmount(item.amount, 2)}</i></div>		
            </div>
          ))
        }
      </div>
     
    </section>
    
  );
};

const mapStateToProps = ({ authUser }) => {
  const { currentUser, loading, assets } = authUser;
  return {currentUser, loading, assets}
};
const mapActionToProps = {
  
};

export default connect(mapStateToProps, mapActionToProps)(Details);

